import {
    SAVE_EQUIPMENT_TYPE,
} from "./EquipmentType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SAVE_EQUIPMENT_TYPE:
            return {
                ...state,
                EquipmentType: action.equipmentType,
            };
        default:
            return state;
    }
};

export default reducer;
